export const appSettingsMessageActivityMessages = "/app_settings/message_activity_messages";
